<mat-form-field
  [class]="{ 'details-textarea': true, hovering: isHovering }"
  appearance="outline"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <textarea
    matInput
    cdkTextareaAutosize
    #autosize="cdkTextareaAutosize"
    cdkAutosizeMinRows="2"
    cdkAutosizeMaxRows="15"
    [formControl]="areaControl"
    (focus)="onFocus()"
    (blur)="onBlur($event)"
  ></textarea>
  <mat-icon matPreffix aria-hidden="true">{{ icon | async }}</mat-icon>
  <mat-error *ngIf="errorMessage && areaControl.invalid">
    {{ errorMessage }}
  </mat-error>
</mat-form-field>
